import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "./album.css";
import * as FaIcons from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AlbumPage from "./albumPage";
import DataTL from "./data";
import { TimeLineData } from "./timeLineData";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Cookie from "js-cookie";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      className="panel"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Album = () => {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(
    location.state ? location.state.page || 0 : 0
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [decade, setDecade] = useState(0);
  const [bg, setBg] = useState(location.state ? location.state.bg || 1 : 1);
  const timelineItems = Array.from({ length: 8 }).map((_, index) => index);
  const timelineColors = ["#80D5E4", "#7EC490", "#FF7547", "#9E74CE"];
  const [isLoading, setIsLoading] = useState(true);
  const [totalCards, setTotalCards] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    const timeoutId = setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    const authToken = Cookie.get("token");
    const isLoggedIn = !!authToken;

    if (!isLoggedIn) {
      return navigate("/");
    }
    const decodedToken = jwtDecode(authToken);
    const isTokenExpired = decodedToken.exp < Date.now() / 1000;

    if (isTokenExpired) {
      Cookie.remove("token");
      return navigate("/logout");
    } else {
      const apiUrl = process.env.REACT_APP_API_BASE_URL;
      const userData = jwtDecode(Cookie.get("token"));
      const userId = userData.userId;
      axios
        .get(`${apiUrl}/questions/${userId}`)
        .then((response) => {
          const total = response.data.length;
          setTotalCards(total);
        })
        .catch(() => {
          toast.error(
            "Oops, hubo un error y no pudimos obtener tus figuritas",
            {
              style: {
                fontFamily: "Noto Sans",
                fontSize: "16px",
                textAlign: "left",
              },
            }
          );
        });
    }
  }, [navigate]);

  const complete = (totalCards / 40) * 100;

  const handleNextPage = () => {
    if (currentPage < 9) {
      setCurrentPage(currentPage + 1);
      handleBg(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 0 && currentPage < 10) {
      setCurrentPage(currentPage - 1);
      handleBg(currentPage - 1);
    }
  };

  const handleBg = (currentPage) => {
    const bgMappings = {
      1: 1,
      2: 1,
      3: 2,
      4: 2,
      5: 3,
      6: 3,
      7: 4,
      8: 4,
    };
    setBg(bgMappings[currentPage] || 0);
  };

  const openModal = (item) => {
    setIsModalOpen(true);
    setDecade(item);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const authToken = Cookie.get("token");
  const isLoggedIn = !!authToken;

  if (!isLoggedIn) {
    return navigate("/");
  }

  const deleteAlbum = () => {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const userData = jwtDecode(Cookie.get("token"));
    const userId = userData.userId;
    axios
      .delete(`${apiUrl}/questions/${userId}`)
      .then(() => {
        toast.success("Álbum reiniciado correctamente", {
          style: {
            fontFamily: "Noto Sans",
            fontSize: "16px",
            textAlign: "left",
          },
        });
        window.location.reload();
      })
      .catch(() => {
        toast.error("Oops, hubo un problema al reiniciar el álbum", {
          style: {
            fontFamily: "Noto Sans",
            fontSize: "16px",
            textAlign: "left",
          },
        });
      });
  };

  const renderCommonContent = () => (
    <div style={{ width: "100%", padding: "0 40px" }}>
      <p>Figuritas obtenidas: {totalCards}/40</p>
      <div
        style={{
          width: "100%",
          border: "1px solid #ccc",
          borderRadius: "5px",
        }}
      >
        <div
          style={{
            width: `${complete}%`,
            height: "20px",
            backgroundColor: "#7ec490",
            borderRadius: "5px",
          }}
        />
      </div>
    </div>
  );

  const renderActionButtons = () => (
    <>
      {totalCards === 40 ? (
        <button className="button button-incorrect" onClick={deleteAlbum}>
          Reiniciar Álbum
        </button>
      ) : (
        <Link className="button button-primary" to="/trivia">
          ¡Ir a las trivias!
        </Link>
      )}
    </>
  );

  const renderAlbumContent = () => (
    <div className="main">
      {isLoading && (
        <div className="overlay">
          <div className="parent loadership loader-front">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      {!isLoading && (
        <section
          className="album"
          style={{
            backgroundImage: `url(../../../../images/fp-${bg}.jpg)`,
          }}
        >
          <div className="nav-pages">
            <button
              title="Anterior"
              className={`btn-nav ${currentPage === 0 ? "btn-disabled" : ""}`}
              onClick={handlePreviousPage}
            >
              <FaIcons.FaChevronCircleLeft />
            </button>
            <button
              title="Siguiente"
              className={`btn-nav ${currentPage === 9 ? "btn-disabled" : ""}`}
              onClick={handleNextPage}
            >
              <FaIcons.FaChevronCircleRight />
            </button>
          </div>
          <h2 className="p-title">
            {1983 + (currentPage - 1) * 5} - {1983 + currentPage * 5}
          </h2>
          <div className="pages">
            <AlbumPage pageNumber={currentPage} />
          </div>

          <hr className="hr-tl" />
          <div className="time-line">
            {timelineItems.map((item, index) => (
              <div
                className="dot"
                key={index}
                style={{
                  backgroundColor:
                    currentPage === item + 1
                      ? timelineColors[
                          Math.floor(item / 2) % timelineColors.length
                        ]
                      : "#265384",
                }}
                onClick={() => {
                  openModal(item);
                  setCurrentPage(item + 1);
                  handleBg(item + 1);
                }}
              ></div>
            ))}
          </div>
          <span className="tl-text">Línea de tiempo</span>
          <Modal show={isModalOpen} onHide={closeModal}>
            <Modal.Header closeButton>
              <Modal.Title>Línea de tiempo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs
                    value={value}
                    variant="scrollable"
                    onChange={handleChange}
                    aria-label="pestañas"
                  >
                    {decade === 7
                      ? TimeLineData.slice(decade * 5, decade * 5 + 6).map(
                          (i, index) => {
                            return (
                              <Tab
                                label={i.title}
                                {...a11yProps(index)}
                                key={index}
                              />
                            );
                          }
                        )
                      : TimeLineData.slice(decade * 5, decade * 5 + 5).map(
                          (i, index) => {
                            return (
                              <Tab
                                label={i.title}
                                {...a11yProps(index)}
                                key={index}
                              />
                            );
                          }
                        )}
                  </Tabs>
                </Box>
                {decade === 7
                  ? TimeLineData.slice(decade * 5, decade * 5 + 6).map(
                      (i, index) => {
                        return (
                          <CustomTabPanel
                            value={value}
                            key={index}
                            index={index}
                          >
                            {i.data.map((key, ix) => {
                              return (
                                <DataTL
                                  mes={key.month}
                                  detalle={key.detail}
                                  key={ix}
                                />
                              );
                            })}
                          </CustomTabPanel>
                        );
                      }
                    )
                  : TimeLineData.slice(decade * 5, decade * 5 + 5).map(
                      (i, index) => {
                        return (
                          <CustomTabPanel
                            value={value}
                            key={index}
                            index={index}
                          >
                            {i.data.map((key, ix) => {
                              return (
                                <DataTL
                                  mes={key.month}
                                  detalle={key.detail}
                                  key={ix}
                                />
                              );
                            })}
                          </CustomTabPanel>
                        );
                      }
                    )}
              </Box>
            </Modal.Body>
            <Modal.Footer>
              <button className="button button-primary" onClick={closeModal}>
                Cerrar
              </button>
            </Modal.Footer>
          </Modal>
        </section>
      )}
      {renderCommonContent()}
      {renderActionButtons()}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );

  if (currentPage === 0 || currentPage === 9) {
    return (
      <div className="main">
        <section
          className={`album ${currentPage === 0 ? "portada" : "contratapa"}`}
        >
          <div className="nav-pages">
            <button
              title="Anterior"
              className={`btn-nav ${currentPage === 0 ? "btn-disabled" : ""}`}
              onClick={handlePreviousPage}
            >
              <FaIcons.FaChevronCircleLeft />
            </button>
            <button
              title="Siguiente"
              className={`btn-nav ${currentPage === 9 ? "btn-disabled" : ""}`}
              onClick={handleNextPage}
            >
              <FaIcons.FaChevronCircleRight />
            </button>
          </div>
          <h2 className="p-title"> </h2>
          <div className="pages"></div>
          <br />
          <div></div>
        </section>
        {renderCommonContent()}
        {renderActionButtons()}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </div>
    );
  }

  return renderAlbumContent();
};

export default Album;
